jQuery(document).ready(function($){
    $('.testimonials').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.custom-prev'),
        nextArrow: $('.custom-next'),
        rows: 0,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true,
                    prevArrow: false,
                    nextArrow: false,
                }
            }
        ]
    });
    if ($(window).width() < 1025) {
        $('.has-dropdown').on('click',function(){
            let dropdown = $(this).find('.dropdown');
            if ($(this).hasClass('act')) {
                $(dropdown).slideUp();
                $(this).removeClass('act');
            } else {
                $(this).addClass('act');
                $(dropdown).slideDown();
            }
        });
        $('.dropdown a').on('click',function(){
            $('.mobile-menu').slideUp();
        });
    }
    

    $('.burger-menu a').on('click',function(e){
        e.preventDefault();
        if ($(this).hasClass('menu-act')) {
            $('.mobile-menu').slideUp();
            $(this).removeClass('menu-act');
        } else {
            $('.mobile-menu').slideDown();
            $(this).addClass('menu-act');
        }
    });

    function updateCartCount() {
        $.getJSON('/cart.js', function (cart) {
            const cartCount = cart.item_count;
            const $cartCount = $('#cart-count');

            // Update cart count
            $cartCount.text(cartCount);
            $cartCount.show();
            // // Show or hide the cart count based on the number of items
            // if (cartCount > 0) {
            //     $cartCount.show();
            // } else {
            //     $cartCount.hide();
            // }
        });
        
    }

    // Call the function on page load
    updateCartCount();

    // Optionally, call this function when an "Add to Cart" action occurs
    $(document).on('click', '.add-to-cart-button', function () {
        setTimeout(updateCartCount, 500); // Delay to ensure the cart updates
    });
    

    // Mobile responsive
    var slickInitialized = false; // Track if the Slick slider is initialized

    function initializeSlick() {
        if ($(window).width() < 1200 && !slickInitialized) {
            $('.logos').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                rows: 1,
                dots: true,
                autoplay: true,
                autoplaySpeed: 3000,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                ]
            });
            slickInitialized = true;
        }
    }

    function destroySlick() {
        if ($(window).width() >= 1200 && slickInitialized) {
            $('.logos').slick('unslick');
            slickInitialized = false;
        }
    }

    // Initial check on page load
    initializeSlick();

    // Bind to window resize
    $(window).resize(function() {
        initializeSlick();
        destroySlick();
    });

    $('.prod-info-media-thumbs').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        rows: 0,
        arrows: true,
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                }
              },
        ]
    });
    // Function to update the main image and active thumbnail state
    function updateMainImageAndActiveState(currentThumbnail) {
        const fullImageUrl = currentThumbnail.data('full');
        $('.featured-image').attr('src', fullImageUrl);

        // Remove active state from all thumbnails and add to the current one
        $('.prod-thumbs img').removeClass('active-thumbnail');
        currentThumbnail.addClass('active-thumbnail');
    }

    // Change the main image and set active state when a thumbnail is clicked
    $('.prod-info-media-thumbs').on('click', '.thumbnail img', function () {
        updateMainImageAndActiveState($(this));
    });

    // Change the main image and set active state when the slider is navigated
    $('.prod-info-media-thumbs').on('afterChange', function (event, slick, currentSlide) {
        const currentThumbnail = $('.slick-slider .slick-current img');
        updateMainImageAndActiveState(currentThumbnail);
    });

    // Set the initial active state for the first thumbnail
    $('.prod-info-media-thumbs .prod-thumbs img').first().addClass('active-thumbnail');


    $('.qty-add').on('click', function () {
        const input = $(this).siblings('.quantity-input');
        const currentValue = parseInt(input.val()) || 0;
        input.val(currentValue + 1);
    });

    $('.qty-minus').on('click', function () {
        const input = $(this).siblings('.quantity-input');
        const currentValue = parseInt(input.val()) || 0;
        const minValue = parseInt(input.attr('min')) || 0;
        if (currentValue > minValue) {
            input.val(currentValue - 1);
        }
    });
    $('#buyNowButton').on('click', function () {
        const quantity = $('.quantity-input').val(); // Get the quantity
        const variantId = $('input[name="id"]').val(); // Get the variant ID

        // Redirect to the checkout page with the variant and quantity
        window.location.href = `/checkout?updates[${variantId}]=${quantity}`;
    });

    $('.information-accordion').on('click',function(){
        if ($(this).hasClass('acc-act')) {
            $(this).removeClass('acc-act');
            $(this).find('.prod-accordion-content').slideUp();
        } else {
            $(this).addClass('acc-act');
            $(this).find('.prod-accordion-content').slideDown();
        }
    });


    $('a[href*="#"]').on('click', function (e) {
        e.preventDefault(); // Prevent default anchor behavior
    
        const target = $(this).attr('href').split('#')[1]; // Get the target ID
        const currentPath = window.location.pathname; // Current page path
        const linkPath = this.pathname; // Link page path
    
        if (target) {
            // If on the same page or no path specified, smooth scroll
            if (currentPath === linkPath || linkPath === '') {
                if ($(`#${target}`).length) {
                    $('html, body').animate(
                        {
                            scrollTop: $(`#${target}`).offset().top,
                        },
                        1000
                    );
                }
            } 
            // If on a different page, navigate and scroll after load
            else {
                window.location.href = `${linkPath}#${target}`;
            }
        }
    });
    
    // Smooth scroll on page load if there's a hash
    $(document).ready(function () {
        const hash = window.location.hash.replace('#', '');
        if (hash && $(`#${hash}`).length) {
            $('html, body').animate(
                {
                    scrollTop: $(`#${hash}`).offset().top,
                },
                1000
            );
        }
    });
    
    
    

      $('.custom-related-products .prod-cards').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: false,
            rows: 0,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                }, {
                    breakpoint: 620,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
      });
      $('.gall-view-more a').on('click',function(e){
        e.preventDefault();
        $('.gall-none').slideDown();
        $(this).parent().fadeOut();
      });
      $('.has-secondary').on('mouseenter', function() {
        let $this = $(this); // Store the reference to 'this'
        let secondary = $this.find('.prod-img').data('second');
        
        // Stop the current animation and fade out the image
        $this.find('.prod-img').stop(true, true).attr('src',secondary);
        
        // setTimeout(function() {
        //     // Change the image source and fade it back in
        //     $this.find('.prod-img').attr('src', secondary).stop(true, true).animate({ opacity: 1 }, 300);
        // }, 300);
    });

    $('.has-secondary').on('mouseleave', function() {
        let $this = $(this); // Store the reference to 'this'
        let primary = $this.find('.prod-img').data('primary');
        
        // Stop the current animation and fade out the image
        $this.find('.prod-img').stop(true, true).attr('src',primary);
        
        // setTimeout(function() {
        //     // Change the image source and fade it back in
        //     $this.find('.prod-img').attr('src', primary).stop(true, true).animate({ opacity: 1 }, 300);
        // }, 300);
    });

    // Maker Popup :)

    $('.maker-pops').on('click', function () {
        let maker_class = $(this).data('id');
        $('.makers-popup').css('display', 'flex');
        $('.makers-popup-desc').hide(); // Hide all descriptions first
        $('.makers-popup-desc[data-id="' + maker_class + '"]').css('display', 'flex'); // Show the matched description only
    });
    $('.popup-close').on('click',function(e){
        e.preventDefault();
        $('.makers-popup').hide();
        $('.makers-popup-desc').hide(); 
    });
    $(document).on('keydown', function (e) {
        if (e.key === "Escape") {
            $('.makers-popup').hide();
            $('.makers-popup-desc').hide();
        }
    });

    // Gallery Carousel
    $('.video-carousel .carousel-featured').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.video-carousel .carousel-thumbs',
        infinite: true,
        rows: 0,
    });

    $('.video-carousel .carousel-thumbs').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.video-carousel .carousel-featured',
        arrows: true,
        focusOnSelect: true,
        spaceBetween: 24,
        infinite: true,
        rows: 0,
        prevArrow: $('.video-carousel .custom-prev'),
        nextArrow: $('.video-carousel .custom-next'),
        centerMode: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
        ]
    });

    $('.image-carousel .carousel-featured').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.image-carousel .carousel-thumbs',
        infinite: true,
        rows: 0,
    });

    $('.image-carousel .carousel-thumbs').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.image-carousel .carousel-featured',
        arrows: true,
        focusOnSelect: true,
        spaceBetween: 24,
        infinite: true,
        rows: 0,
        prevArrow: $('.image-carousel .custom-prev'),
        nextArrow: $('.image-carousel .custom-next'),
        centerMode: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                }
            }, {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                }
            },
        ]
    });
      
    // $('.prod-variations').on('change', function(){
    //     let selectedOption = $(this).find(':selected'); 
    //     let data_price = selectedOption.data('price')
    //     let compare_price = selectedOption.data('compare-price');
    //     if(compare_price === '') {
    //         $('.product-price').text(data_price);
    //     } else {
    //         $('.product-price ').html('<span class="price-sale">'+ data_price +'</span>');
    //         $('.product-price ').append('<span class="price-compare">'+ compare_price +'</span>');
    //     }
    // });

    $('.input-variant').on('change',function(){
        let data_price = $(this).data('price');
        let compare_price = $(this).data('compare-price');
        if(compare_price === '') {
            $('.product-price').text(data_price);
        } else {
            $('.product-price ').html('<span class="price-sale">'+ data_price +'</span>');
            $('.product-price ').append('<span class="price-compare">'+ compare_price +'</span>');
        }
    });

    $(window).on("scroll", function () {
        if ($(this).scrollTop() > 100) {
            $(".custom-header").addClass("fixed");
        } else {
            $(".custom-header").removeClass("fixed");
        }
    });

});